import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { ExcelValidationsApi } from "@socotec.io/atm-back-sdk";

const api = new ExcelValidationsApi(atmBackConfiguration);

export const validateAcousticExcel = async (documentUuid) => {
  if (!documentUuid) {
    throw new Error("UUID du document requis pour la validation");
  }

  const response = await api.create({
    acousticExcelValidationRequestRequest: { documentUuid },
  });

  return {
    isValid: response.isValid,
    totalErrors: response.totalErrors,
    validationErrors: response.validationErrors || [],
  };
};
